import { createFileRoute } from "@tanstack/react-router";
import SpecialBrandActionsManager from "@/components/admin/SpecialBrandActionsManager";
import { z } from "zod";

export const Route = createFileRoute("/admin/marketing/carrossel")({
  validateSearch: z.object({ criar: z.literal("campanha").optional() }),
  component: CarouselRoute,
});

function CarouselRoute() {
  const search = Route.useSearch();
  return <SpecialBrandActionsManager createOnMount={search.criar === "campanha"} />;
}
